export const SCROLLED_BEYOND_THRESHOLD = 100

export const AI_CHAT_SPECIAL_ID_PREFIX = {
  TIMELINE_SUMMARY: "timeline-summary:",
}
